import templateUrl from './create-user-account.component.html';

/**
 * A component containing an edit form used to register a new user account.
 */
export const CreateUserAccountComponent = {
    templateUrl,
    require: {
        editForm: "?^^form"
    },
    bindings: {
        /** The user being created. */
        user: "<?",
        /** Indicates if fields normally only editable by super users can be edited. */
        isSiteAdmin: "<?",
        /**  Indicates if edits are disabled for the user account details */
        isDisabled: "<?"
    },
    controller: class CreateUserAccountComponent {
        constructor(employeeService) {
            'ngInject';
            this.employeeService = employeeService;
        }

        $onInit() {
            if (this.isSiteAdmin === undefined) {
                this.isSiteAdmin = false;
            }

            if (this.isDisabled === undefined) {
                this.isDisabled = false;
            }

            if (this.user) {
                // Set initial user name, but only on initial load.
                this.userName = this.user.UserName;
                // Perform initial availability check, in case the employee was passed in.
                this._validateUserNameAvailability(this.userName);
            }
        }

        onChangeUserName(userName) {
            if (!this.user.EmailAddress || this.user.EmailAddress === this.user.UserName) {
                // Keep the email address the same as the username unless the email is changed manually.
                this.user.EmailAddress = userName;
            }
            this.user.UserName = userName;
            this._validateUserNameAvailability(userName);
        }

        _validateUserNameAvailability(userName) {
            this.userNamePending = true;
            return this.employeeService.isEmailAddressAvailable(userName)
                .then(available =>
                    this.editForm.UserName.$setValidity("available", available))
                .catch(() => {})
                .then(() => this.userNamePending = false);
        }
    }
};

